// extracted by css-extract-rspack-plugin
module.exports =  {"section_wrapper":"Ydb9P","photowidget":"krOZs"};